/** UA-4-F8 (Final PRD §8, §14, §49): Create Shift "Primary Service" offers ONLY the participant's ACTIVE agreement lines →
 *  PSIs for the shift date (S2 authorised-services payload). No catalogue fallback, no "Show all". */
export const NO_AUTHORITY_MESSAGE = 'No ACTIVE service agreement authorises a billable shift for this participant on this date — create or activate the agreement first (§8)';
export const NOT_EFFECTIVE_MESSAGE = 'The ACTIVE agreement has no line effective on this date — adjust the line dates or pick another date';

/** Flatten the authorised-services payload into selectable options: one per PSI on a line effective on the date. */
export const authorisedOptions = (auth, participantLabel = null) => {
  if (!auth?.agreement) return [];
  const out = [];
  for (const ln of auth.lines || []) {
    if (!ln.effective_on_date) continue;
    for (const psi of ln.participant_service_items || []) {
      const label = `${ln.service_name || 'Service'}${ln.support_item_number ? ` · ${ln.support_item_number}` : ''}${psi.support_ratio ? ` · ${psi.support_ratio}` : ''}`;
      out.push({ value: psi.id, psi_id: psi.id, agreement_line_id: ln.agreement_line_id, service_catalog_id: psi.service_catalog_id || ln.service_catalog_id || '',
        label: participantLabel ? `${participantLabel} — ${label}` : label, agreement_no: auth.agreement.agreement_no });
    }
  }
  return out;
};

/** Selector state for the Create button and the disabled-with-reason selector. */
export const selectorState = (auth, loading = false) => {
  if (loading || auth === undefined) return { disabled: true, reason: 'Loading authorised services…', canCreate: false };
  if (!auth || !auth.agreement) return { disabled: true, reason: NO_AUTHORITY_MESSAGE, canCreate: false };
  const opts = authorisedOptions(auth);
  if (opts.length === 0) return { disabled: true, reason: NOT_EFFECTIVE_MESSAGE, canCreate: false };
  return { disabled: false, reason: '', canCreate: true, options: opts };
};

/** UA-4-F9: picker helper — disabled-with-reason from the batch eligibility read ({ [workerId]: { eligible, reason } }). */
export const eligibilityState = (workerId, eligibility) => {
  const e = eligibility?.[workerId];
  if (!e) return { disabled: false, reason: '' };
  return e.eligible ? { disabled: false, reason: '' }
    : { disabled: true, reason: `Not eligible — ${e.reason || 'assignment blocked'}`, ...(e.screening ? { screening: e.screening } : {}) };   // BS3-005
};

/** Polish: "Thu 9 Oct 2026" (TZ-safe for ISO dates). */
export const readableDate = (iso) => {
  if (!iso) return '';
  const [y, m, d] = String(iso).slice(0, 10).split('-').map(Number);
  if (!y || !m || !d) return String(iso);
  return new Date(Date.UTC(y, m - 1, d)).toLocaleDateString('en-AU', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric', timeZone: 'UTC' }).replace(/,/g, '');
};
